import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import { LaboDTO } from '../../customs/_models/LaboDTO';

@Injectable({
    providedIn: 'root'
})
export class LaboService {

    constructor(private http: HttpClient,
                private endPoint: Endpoints,
                private dialogService: DialogService,) {
    }

    generateOT(selctedSamples: SampleDTO[]) : Observable<CommonResponse | null>  {
        if (selctedSamples.length < 1) {
            this.dialogService.openDangerDialog('Aucun échantillon selectionne');
            return of(null)
        }
        let dto: OT_DTO[] = []
        selctedSamples.forEach(
            (sample) => {
                dto.push({sampleId: sample.id, typeAnalyseId: sample.idAT!})
            }
        )
        let typeAnalyseId: number = dto[0].typeAnalyseId
        for (const element of dto) {
            if (typeAnalyseId == -1) {
                this.dialogService.openDangerDialog("Type analyse n'exists pas dans les échantillions");
                return of(null)
            }
            if (element.typeAnalyseId != typeAnalyseId) {
                this.dialogService.openDangerDialog('Les échantillons doivent être du même type d\'analyse.');
                return of(null)
            }
        }

        return this.http.post<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/generateOT`, dto)
    }

    findAll(): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(this.endPoint.labo_endpoint)
    }

    update(laboId: number, laboData: FormData): Observable<CommonResponse> {
  const url = `${this.endPoint.labo_endpoint}/${laboId}`;
  return this.http.put<CommonResponse>(url, laboData); // FormData directement
}



    delete(id: number) :Observable<CommonResponse>{
        return this.http.delete<CommonResponse>(`${this.endPoint.labo_endpoint}/${id}`)
    }

    createLabo(dtos: any): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(`${this.endPoint.labo_endpoint}`, dtos);
      }
}
